module.exports = "<svg id=\"c8c66f84-f119-45ef-ac3e-913d0dc56aeb\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43 69\"><title>ArrowRt</title><g id=\"cc40e0cd-9626-45d4-8a14-05f320f13886\" data-name=\"Mockup-V2.0\"><g id=\"d0f552fc-5423-4d33-8db8-97598f1dd63a\" data-name=\"V3\"><polygon id=\"89aa0b18-6571-4cbf-acde-d95ee07ba1ed\" data-name=\"Fill-1\" points=\"0 0 0 15.13 25 34.5 0 53.72 0 69 43 34.5 0 0\"></polygon></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ArrowRt.svg
// module id = NJ04
// module chunks = 2